import React from 'react'
import Select from 'react-select'

const FeedSelector = ({ options, assignedFeeds, label, placeholder }) => {
  /* console.log(options, " el options ------------------ ")
  console.log(assignedFeeds[0], " assignedFeeds[0] 🐶🐶🐶") */

  const selectAction = (value, action) => {
    if (action.action === 'select-option') assignedFeeds[1](value)
    if (action.action === 'clear') assignedFeeds[1]()
    if (action.action === 'remove-value')
      assignedFeeds[1](assignedFeeds[0].filter((item) => item.value !== action.removedValue.value))
  }

  return (
    <>
      <label>{label}</label>

      <Select
        name="usersGroupsSelected"
        defaultValue={assignedFeeds[0]}
        placeholder={placeholder}
        isMulti
        options={options}
        styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
        onChange={selectAction}
      />
    </>
  )
}
export default FeedSelector
